export default function BuyingGuide() {
  const steps = [
    {
      step: "01",
      icon: "ri-search-line",
      title: "Find Products",
      desc: "Browse our curated spreadsheets to discover trending products across sneakers, clothing, bags, and accessories categories. Every listing includes seller ratings and price data.",
    },
    {
      step: "02",
      icon: "ri-scales-3-line",
      title: "Compare Sellers",
      desc: "Use side-by-side comparison tools to evaluate different sellers based on price, shipping speed, and customer reviews. Make confident, informed purchasing decisions.",
    },
    {
      step: "03",
      icon: "ri-ship-line",
      title: "Ship to Warehouse",
      desc: "Once you place an order, your items are shipped to Sugargoo's secure warehouse facility where they are inspected and stored safely before international shipping.",
    },
    {
      step: "04",
      icon: "ri-image-line",
      title: "Check QC Photos",
      desc: "Review detailed quality control photos of your items before they leave the warehouse. Verify colors, sizing, logos, and overall condition to ensure everything meets your expectations.",
    },
    {
      step: "05",
      icon: "ri-box-3-line",
      title: "Complete Purchase",
      desc: "After approving QC photos, choose your preferred international shipping method and complete your order. Track your package all the way to your doorstep.",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Step by Step
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            How <span className="text-primary-500">Sugargoo</span> Works
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            New to Sugargoo? Follow this simple five-step buying guide to go from product discovery to successful delivery with confidence.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-[39px] top-12 bottom-12 w-0.5 bg-background-200"></div>

          <div className="flex flex-col gap-6">
            {steps.map((item, i) => (
              <div key={item.step} className="flex gap-5 items-start">
                <div className="relative z-10 w-20 h-20 flex-shrink-0 rounded-full bg-primary-500 text-white flex items-center justify-center">
                  <span className="text-sm font-bold font-label">{item.step}</span>
                </div>
                <div className="flex-1 pt-0.5">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                      <i className={`${item.icon} text-base`}></i>
                    </div>
                    <h4 className="text-lg font-semibold font-heading text-foreground-900">
                      {item.title}
                    </h4>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed ml-12">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}